import { onEnter } from "@/utils/keyboard/events";
import Input from "../../components/Input";
import StepLayout from "../../components/StepLayout";
import { SQFForm, SQFStepOf } from "../../hooks/useServiceQuoteFlow";
import { useStore } from "@tanstack/react-form";
import { isMobile } from "@/utils/is-mobile";
import { cn } from "@networx/utils/tailwind/cn";

export default function HomeownerNameStep({ step, form, onClickPrev }: Props) {
  const fullName = useStore(form.store, (state) => state.values.name);
  if (step?.hidden) return null;

  return (
    <StepLayout
      title={step.title}
      subtitle="Get your free quotes now - no obligation"
      onClickPrev={onClickPrev}
      buttonProps={{
        onClick: step.next,
        isDisabled: !step.canContinue(fullName),
        className: "sm:w-[420px]"
      }}
      fullWidthNextButton
      classNames={{
        headerWrapper: "sm:px-[27px]",
        children: cn({ "items-center": isMobile() })
      }}
    >
      <form.Field
        name="name"
        validators={step.fields.name.validators}
        listeners={{
          onChange: () => {
            if (step.autoForward) {
              step.resolve();
            }
          },
          onBlur: () => {
            if (isMobile()) {
              document.body.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            }
          }
        }}
        children={(field) => {
          const inputProps = step.fields.name.props(field);
          return (
            <Input
              {...inputProps}
              showIcon={!isMobile() && inputProps.showIcon}
              // @ts-expect-error type issue, but it's working
              onKeyDown={onEnter((e) => {
                (e.target as HTMLInputElement | undefined)?.blur?.();
                step.next();
              })}
              placeholder="Full Name"
              variant="bordered"
              errorPreset={isMobile() ? "solid" : "float"}
              autoComplete="name"
              classNames={{
                base: cn({ "max-w-[320px]": isMobile() }, "sm:w-[420px]"),
                inputWrapper: "py-0 h-[42px] rounded-[4px] sm:rounded-[3px] border-1 border-[color:rgba(67,91,108,0.43)] sm:border-[color:rgb(203,195,180)] !shadow-[inset_0_1px_2px_rgba(0,0,0,0.2)] sm:!shadow-none",
                input: "text-[#666] sm:text-black text-[16px] placeholder:text-[18px]",
              }}
            />
          )
        }
        }
      />
    </StepLayout>
  );
}


interface Props {
  step: SQFStepOf<"homeowner-full-name">;
  form: SQFForm;
  onClickPrev?: () => void;
}
